import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { RequireAuth } from './components/RequireAuth';
import { AppLayout } from './layouts/AppLayout';
import { SignInPage, SignUpPage } from './pages/AuthPages';
import { CreditsPage } from './pages/CreditsPage';
import { DashboardPage } from './pages/DashboardPage';
import { DocsPage } from './pages/DocsPage';
import { HistoryPage } from './pages/HistoryPage';
import { HomePage } from './pages/HomePage';
import { NewReviewPage } from './pages/NewReviewPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PullRequestsPage } from './pages/PullRequestsPage';
import { ReviewDetailPage } from './pages/ReviewDetailPage';
import { SettingsPage } from './pages/SettingsPage';

/** Keeps old bookmarks like /reviews/:id working after the app moved under /app. */
function LegacyReviewRedirect() {
  const { id = '' } = useParams();
  return <Navigate to={`/app/reviews/${id}`} replace />;
}

export function App() {
  return (
    <Routes>
      <Route index element={<HomePage />} />
      <Route path="signin" element={<SignInPage />} />
      <Route path="signup" element={<SignUpPage />} />
      <Route path="reviews/:id" element={<LegacyReviewRedirect />} />
      <Route
        path="app"
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="pull-requests" element={<PullRequestsPage />} />
        <Route path="new" element={<NewReviewPage />} />
        <Route path="reviews/:id" element={<ReviewDetailPage />} />
        <Route path="history" element={<HistoryPage />} />
        <Route path="credits" element={<CreditsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="docs" element={<DocsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
